import { render, staticRenderFns } from "./ViewWindow.vue?vue&type=template&id=b0f8eca6&"
import script from "./ViewWindow.vue?vue&type=script&lang=ts&"
export * from "./ViewWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports